import React, { Component } from 'react';
import './mobileOverlaySuggestingDesktop.css';
import InlineSvg from '../InlineSvg';
import customWorksLogo from './../img/custom-works-logo.svg';
import isTablet from '../utils/isTablet';

class MobileOverlaySuggestingDesktop extends Component {

  render() {
    const message = isTablet
      ? 'Please rotate your tablet to enjoy the experience'
      : 'Please use a tablet or desktop to enjoy the experience';

    return (
      <div className="mobileOverlaySuggestingDesktop">
        <div className="mobileOverlaySuggestingDesktop__inner">
          <InlineSvg className="logo" svg={customWorksLogo} />
          <p>{message}</p>
        </div>
      </div>
    );
  }
}

export default MobileOverlaySuggestingDesktop;



// WEBPACK FOOTER //
// ./src/components/MobileOverlaySuggestingDesktop.js